import { Input, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { masterCashes = [] } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <Input
                label="Pencarian"
                placeholder="Cari..."
                variant="flat"
                value={pending.search || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        search: val,
                    }))
                }
                isClearable
                onClear={() =>
                    setPending((prev) => ({
                        ...prev,
                        search: "",
                    }))
                }
            />

            <Select
                label="Tipe Transaksi"
                placeholder="Semua Tipe"
                variant="flat"
                selectedKeys={pending.type ? [String(pending.type)] : []}
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        type: Array.from(keys)[0],
                    }))
                }
            >
                <SelectItem key="1">Pemasukan</SelectItem>
                <SelectItem key="2">Pengeluaran</SelectItem>
            </Select>

            <Input
                type="date"
                label="Tanggal Mulai"
                variant="flat"
                value={pending.start_date || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        start_date: val,
                    }))
                }
            />

            <Input
                type="date"
                label="Tanggal Akhir"
                variant="flat"
                value={pending.end_date || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        end_date: val,
                    }))
                }
            />

            <Select
                label="Dompet/Kas"
                placeholder="Pilih Kas"
                variant="flat"
                selectedKeys={
                    pending.master_cash_id
                        ? [String(pending.master_cash_id)]
                        : []
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        master_cash_id: Array.from(keys)[0],
                    }))
                }
            >
                {masterCashes.map((item) => (
                    <SelectItem key={item.value}>{item.title}</SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
